import React from 'react';
import './OrderCard.css';

export default function OrderCard({ order }) {
  const getStatusColor = (status) => {
    const statusMap = {
      pending: '#ffc107',
      confirmed: '#17a2b8',
      processing: '#007bff',
      'out-for-delivery': '#fd7e14',
      delivered: '#28a745',
      cancelled: '#dc3545'
    };
    return statusMap[status?.toLowerCase()] || '#6c757d';
  };

  const getStatusEmoji = (status) => {
    const emojiMap = {
      pending: '⏳',
      confirmed: '✅',
      processing: '📦',
      'out-for-delivery': '🚚',
      delivered: '🎉',
      cancelled: '❌'
    };
    return emojiMap[status?.toLowerCase()] || '📋';
  };

  const parseItems = (items) => {
    try {
      if (!items) return [];
      if (Array.isArray(items)) return items;
      if (typeof items === 'string') return JSON.parse(items);
      return [];
    } catch {
      return [];
    }
  };

  const items = parseItems(order.items);
  const statusColor = getStatusColor(order.status);
  const statusEmoji = getStatusEmoji(order.status);

  return (
    <div className="order-card">
      <div className="order-header">
        <div className="order-header-left">
          <h3 className="order-number">
            {order.order_number || `Order #${order.id}`}
          </h3>
          <p className="order-date">
            {new Date(order.created_at).toLocaleDateString('en-US', {
              year: 'numeric',
              month: 'short',
              day: 'numeric',
              hour: '2-digit',
              minute: '2-digit'
            })}
          </p>
        </div>
        <div 
          className="order-status-badge"
          style={{ backgroundColor: `${statusColor}20`, color: statusColor }}
        >
          <span className="status-emoji">{statusEmoji}</span>
          <span className="status-text">
            {order.status?.replace('-', ' ').toUpperCase()}
          </span>
        </div>
      </div>

      <div className="order-items">
        <h4 className="items-title">Items:</h4>
        {items.length === 0 ? (
          <p className="no-items">No items found</p>
        ) : (
          <ul className="items-list">
            {items.map((item, index) => (
              <li key={index} className="order-item">
                <span className="item-name">
                  • {item.name || 'Item'} x {item.quantity || 1}
                </span>
                <span className="item-price">
                  Rs. {(item.price || 0) * (item.quantity || 1)}
                </span>
              </li>
            ))}
          </ul>
        )}
      </div>

      <div className="order-delivery">
        <h4 className="delivery-title">📍 Delivery Information:</h4>
        <p className="delivery-address">{order.delivery_address || '—'}</p>
        <p className="delivery-phone">📞 {order.delivery_phone || '—'}</p>
      </div>

      <div className="order-footer">
        <div className="payment-method">
          <span className="payment-label">Payment:</span>
          <span className="payment-value">
            {order.payment_method?.toUpperCase() || 'CASH'}
          </span>
        </div>
        <div className="order-total">
          <span className="total-label">Total Amount:</span>
          <span className="total-amount">Rs. {order.total_amount || 0}</span>
        </div>
      </div>
    </div>
  );
}